<div class="all-in-one-table content-layout">
  <calsoft-page-header [height]="'180px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
  </calsoft-page-header>

  <div class="container">
    <calsoft-breadcrumbs [attr.guide]="sanitizedUrl + '-breadcrumbs'" [url]="'product'" [currentPage]="'Products'"
      [header]="'primary'"></calsoft-breadcrumbs>

    <div *ngIf="GridType !=  8">
      <calsoft-list [progress]="spinner" name="Product" [filterSelectObj]="filterSelectObj" [columns]="columns"
        (filterChangeColumn)="onFilterChangeColumn($event)" (filterChange)="onFilterChange($event)">
        <div (click)="bulkUpload ? restritionPopup() : null" class="actions" fxFlexAlign="center">
          <div [ngClass]="{ overlayProduct:bulkUpload }">
            <button [attr.guide]="sanitizedUrl + '-view-headline-btn'" mat-button [matMenuTriggerFor]="menu">
              <mat-icon>view_headline</mat-icon>
              <mat-icon>arrow_drop_down</mat-icon>
            </button>
          </div>

        </div>

        <div class="actions" fxFlexAlign="center" *ngIf="!productLimitedRestriction">
          <button [attr.guide]="sanitizedUrl + '-add-product-btn'" [disabled]="!resourcePrivilege?.create"
            class="create" (click)="addproduct()" type="button" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="actions" fxFlexAlign="center" (click)="restritionPopup()" *ngIf="productLimitedRestriction">
          <button [attr.guide]="sanitizedUrl + '-restricted-add-product-btn'" [disabled]="pageList>=
        productLimitedRestrictionValue" class="create" (click)="addproduct()" type="button" mat-mini-fab
            color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>


        <mat-menu [overlapTrigger]="false" xPosition="before" #menu="matMenu" class="custom-action-menu">
          <a [attr.guide]="sanitizedUrl + '-export-excel-template-lnk'" mat-menu-item (click)="exportExcel()">
            <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
            <span>Export-Excel-Template</span>
          </a>
          <a [attr.guide]="sanitizedUrl + '-import-excel-lnk'" mat-menu-item (click)="importExcel()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Import-Excel</span>
          </a>
          <a [attr.guide]="sanitizedUrl + '-import-excel-advance-lnk'" [ngClass]="{ overlayProduct:bulkUpload }"
            mat-menu-item (click)="importExcelAdvance()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Import-Excel-Advance</span>
          </a>


          <a [attr.guide]="sanitizedUrl + '-download-qty-price-template-lnk'" mat-menu-item
            (click)="downloadReportTemplate()">
            <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
            <span>Download Template Product Qty Price Update</span>
          </a>

          <a [attr.guide]="sanitizedUrl + '-import-qty-price-lnk'" mat-menu-item (click)="openImportDataPopup()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Excel Import Product Qty Price Update</span>
          </a>

          <a [attr.guide]="sanitizedUrl + '-download-name-desc-template-lnk'" mat-menu-item
            (click)="downloadTemplate1()">
            <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
            <span>Download Name And Description Update Template</span>
          </a>

          <a [attr.guide]="sanitizedUrl + '-import-name-desc-lnk'" mat-menu-item (click)="openImportDataPopup1()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Excel Import Product Name Update</span>
          </a>

          <a [attr.guide]="sanitizedUrl + '-bulk-image-import-lnk'" [ngClass]="{ overlayProduct:bulkUpload }"
            mat-menu-item (click)="ImportImageImport()">
            <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
            <span>Bulk Image Import </span>
          </a>

          <!-- <button [attr.guide]="sanitizedUrl + '-my-shop-btn'" mat-menu-item (click)="sitedata()">
        <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
        <span>my shop</span>
      </button> -->

          <!-- <button [attr.guide]="sanitizedUrl + '-export-data-btn'" mat-menu-item (click)="downloadReport('full')">
        <mat-icon class="material-icons-outlined mat-icon-sm">
          import_export</mat-icon>
        <span>Export Data</span>
      </button> -->

          <a [attr.guide]="sanitizedUrl + '-download-filter-lnk'" mat-menu-item
            (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
            <mat-icon>cloud_download</mat-icon>
            <span>Download</span>
          </a>

          <div *ngIf="selectionProduct.length>0">
            <a [attr.guide]="sanitizedUrl + '-download-selected-lnk'" mat-menu-item
              (click)="downloadReport('selected')">
              <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
              <span>Download Selected</span>
            </a>
          </div>

          <button [attr.guide]="sanitizedUrl + '-delete-all-btn'" [disabled]="!resourcePrivilege?.delete" mat-menu-item
            (click)="deleteAllProductDialog()">
            <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
            <span> Delete All </span>
          </button>
        </mat-menu>

        <div *ngIf="read" [ngClass]="elements==0?'none':elements>5?'example-container':'none'" style="overflow-x:auto;">

          <mat-table #table [dataSource]="productList" matSort (matSortChange)="sortData($event)"
            style="user-select:none">



            <!-- fullName Column -->
            <ng-container *ngFor="let column of columns">
              <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.name }}</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row[column.property] }}</mat-cell>
              </ng-container>
            </ng-container>


            <ng-container matColumnDef="isInStock">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.isInStock == '1' ? "Yes" : "No"}}

              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="image">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Image</mat-header-cell>
              <mat-cell *matCellDef="let row">

                <span *ngIf="!row?.productImageUrl || !row.productImageUrl.includes('http')">
                  <calsoft-common-images [src]="getImage(row.productImageUrl,row.images,row)" [height]="'65px'"
                    [width]="'auto'" [alt]="">

                  </calsoft-common-images>
                </span>

                <span *ngIf="row?.productImageUrl && row.productImageUrl.includes('http')">
                  <img style="height: 65px;width: auto;" [src]="row.productImageUrl | safe: 'resourceUrl'"
                    onerror="this.src='assets/images/logo/no-image.png';" alt="">
                </span>


              </mat-cell>

            </ng-container>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{(row.name) | slice:0:20}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <span>
                  Select
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox [attr.guide]="sanitizedUrl + '-checkbox-' + row.incrementId"
                  (click)="$event.stopPropagation()" (change)="changeValue($event.checked,row)"
                  [checked]="selectionProduct.indexOf(row) >= 0" [aria-label]="checkboxLabel(row.incrementId)">
                </mat-checkbox>

              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{(row.createdDate) | date:'medium' }}
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Updated Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{(row.updatedDate) | date:'medium' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="categoryNames">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Category</mat-header-cell>
              <mat-cell *matCellDef="let row">

                <ng-container *ngFor="let value of row.categoryNames let  k = index">
                  {{value}} {{ k < row.categoryNames.length - 1 ? ',' : '' }} </ng-container>

              </mat-cell>
            </ng-container>
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
              <mat-header-cell class="actions-cell" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell class="actions-cell" *matCellDef="let row">
                <button [attr.guide]="sanitizedUrl + '-action-menu-btn'" type="button" mat-icon-button
                  [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button [attr.guide]="sanitizedUrl + '-edit-product-item-btn'" [disabled]="!resourcePrivilege?.update"
                    (click)="editProduct(row.entityId,row.attributeSetId,row.type)" mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    <span>edit</span>
                  </button>

                  <button [attr.guide]="sanitizedUrl + '-delete-product-item-btn'"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId(row.entityId)" mat-menu-item>
                    <mat-icon>delete</mat-icon>
                    <span>delete</span>
                  </button>
                  <!-- <button [attr.guide]="sanitizedUrl + '-delete-customer-btn'" (click)="deleteCustomer(row)" mat-menu-item>
                  <span>Delete</span>
                </button>  -->
                </mat-menu>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
            </mat-row>
          </mat-table>
        </div>
        <div class="products-padding" fxLayoutAlign="center center"
          *ngIf="productList?.data?.length === 0 || productList?.length === 0">
          No records found
        </div>


        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
          <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
          <mat-paginator [attr.guide]="sanitizedUrl + '-pagination'" class="paginator" (page)="getUpdate($event)"
            showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
            [pageSizeOptions]="pageSizeValue"> </mat-paginator>
        </div>
      </calsoft-list>
    </div>

    <div *ngIf="GridType ==  8" class="table-responsive custom-table gridtable-class"
      [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row" [fxLayoutGap]="rowgap"
      style="width: 100%; overflow-x: auto;">
      <div [fxFlex]="rowLeft" *ngIf="isGridVisible" style="width: 100%;">
        <div class="crm-container-new-eight">

          <main class="main-content">

            <section class="contacts-view">
              <div fxLayoutAlign="space-between center" class="contacts-header">

                <div fxFlex>
                  <h2 class="sg-title">{{(currentRouterPath | moduleName) || 'Product'}}</h2>
                </div>

                <div class="contact-actions">
                  <button [attr.guide]="sanitizedUrl + '-refresh-btn'" class="btn btn-outline bhover"
                    (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                    Refresh</button>
                  <button [attr.guide]="sanitizedUrl + '-add-new-product-btn'" class="btn btn-primary"
                    (click)="addproduct()"><mat-icon>add</mat-icon>Add</button>
                  <!-- Your trigger button -->
                  <button [attr.guide]="sanitizedUrl + '-more-options-btn'" class="btn btn-outline bhover"
                    [matMenuTriggerFor]="menu" matTooltip="More Options">
                    <mat-icon>more_horiz</mat-icon>

                  </button>

                  <!-- The mat-menu itself -->
                  <mat-menu [overlapTrigger]="false" xPosition="before" #menu="matMenu" class="custom-action-menu">
                    <a [attr.guide]="sanitizedUrl + '-export-excel-template-lnk-v2'" mat-menu-item
                      (click)="exportExcel()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                      <span>Export-Excel-Template</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-import-excel-lnk-v2'" mat-menu-item (click)="importExcel()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                      <span>Import-Excel</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-import-excel-advance-lnk-v2'"
                      [ngClass]="{ overlayProduct: bulkUpload }" mat-menu-item (click)="importExcelAdvance()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                      <span>Import-Excel-Advance</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-download-qty-price-template-lnk-v2'" mat-menu-item
                      (click)="downloadReportTemplate()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                      <span>Download Template Product Qty Price Update</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-import-qty-price-lnk-v2'" mat-menu-item
                      (click)="openImportDataPopup()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                      <span>Excel Import Product Qty Price Update</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-download-name-desc-template-lnk-v2'" mat-menu-item
                      (click)="downloadTemplate1()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                      <span>Download Name And Description Update Template</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-import-name-desc-lnk-v2'" mat-menu-item
                      (click)="openImportDataPopup1()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                      <span>Excel Import Product Name Update</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-bulk-image-import-lnk-v2'"
                      [ngClass]="{ overlayProduct: bulkUpload }" mat-menu-item (click)="ImportImageImport()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
                      <span>Bulk Image Import</span>
                    </a>

                    <a [attr.guide]="sanitizedUrl + '-download-filter-lnk-v2'" mat-menu-item
                      (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
                      <mat-icon>cloud_download</mat-icon>
                      <span>Download</span>
                    </a>

                    <div *ngIf="selectionProduct.length > 0">
                      <a [attr.guide]="sanitizedUrl + '-download-selected-lnk-v2'" mat-menu-item
                        (click)="downloadReport('selected')">
                        <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
                        <span>Download Selected</span>
                      </a>
                    </div>

                    <button [attr.guide]="sanitizedUrl + '-delete-all-btn-v2'" [disabled]="!resourcePrivilege?.delete"
                      mat-menu-item (click)="deleteAllProductDialog()">
                      <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
                      <span>Delete All</span>
                    </button>
                  </mat-menu>

                </div>
              </div>

              <div class="table-controls-wrapper">

                <div class="table-controls" *ngIf="selection.isEmpty()">

                  <div class="contacts-header">
                    <div class="contact-actions">

                      <!-- <button [attr.guide]="sanitizedUrl + '-table-chart-btn'" class="btn btn-outline" mat-button [matMenuTriggerFor]="viewTableMenu"
                      style="justify-content: center;"><mat-icon>table_chart</mat-icon> Table
                    </button> -->

                      <button [attr.guide]="sanitizedUrl + '-layers-btn'" mat-button [matMenuTriggerFor]="viewMenu"
                        class="btn-two btn-outline bhover">
                        <mat-icon>layers</mat-icon>
                      </button>

                      <!-- <mat-menu #viewTableMenu="matMenu">
                      <button [attr.guide]="sanitizedUrl + '-table-view-btn'" mat-menu-item (click)="setTableView('tableView')">
                        <mat-icon>table_chart</mat-icon>
                        <span style="margin-left: 8px;">Table View</span>
                        <i *ngIf="tableViewMode === 'tableView'" class="fas fa-check" style="margin-left: 5px;"></i>
                      </button>
                      <button [attr.guide]="sanitizedUrl + '-kanban-view-btn'" mat-menu-item (click)="setTableView('kanbanView')">
                        <mat-icon>view_column</mat-icon>
                        <span style="margin-left: 8px;">Kanban View</span>
                        <i *ngIf="tableViewMode === 'kanbanView'" class="fas fa-check" style="margin-left: 5px;"></i>
                      </button>
                    </mat-menu> -->

                      <mat-menu #viewMenu="matMenu">
                        <button [attr.guide]="sanitizedUrl + '-compact-view-btn'" mat-menu-item
                          (click)="setView('compact')">
                          <mat-icon>compress</mat-icon>
                          <span style="margin-left: 8px;">Compact</span>
                          <mat-icon *ngIf="viewMode === 'compact'" style="margin-left:5px;">check</mat-icon>
                        </button>
                        <button [attr.guide]="sanitizedUrl + '-comfortable-view-btn'" mat-menu-item
                          (click)="setView('comfortable')">
                          <mat-icon>expand</mat-icon>
                          <span style="margin-left: 8px;">Comfortable</span>
                          <mat-icon *ngIf="viewMode === 'comfortable'" style="margin-left:5px;">check</mat-icon>
                        </button>
                      </mat-menu>

                      <button [attr.guide]="sanitizedUrl + '-filter-btn'"
                        class="btn btn-outline bhover d-flex align-items-center gap-2"
                        [class.active-filter]="filterActive" (click)="toggleFilterPanel()">
                        <mat-icon class="me-1">
                          {{ filterActive ? 'filter_alt' : 'filter_list' }}
                        </mat-icon>

                        <span>Filter</span>

                        <span *ngIf="filterActive" class="filter-pill">
                          <mat-icon class="pill-icon">check_circle</mat-icon>
                        </span>
                      </button>
                      <button [attr.guide]="sanitizedUrl + '-filter-columns-btn'" class="btn btn-outline bhover"
                        (click)="toggleFilterColumnPanel()">
                        Filter by Columns
                      </button>

                    </div>
                  </div>


                </div>

              </div>

              <div class="leads-content-area" [class.filter-open]="isFilterPanelOpen"
                [class.filter-column-open]="isFilterPanelColumnOpen">
                <div class="table-wrapper">

                  <table mat-table [dataSource]="productList" matSort (matSortChange)="sortData($event)"
                    class="contacts-table" [ngClass]="viewMode">

                    <ng-container *ngFor="let col of columns; trackBy: trackByProp" [sticky]="!isMobile && col.isSticky"
                      [matColumnDef]="col.property">
                      <ng-container *ngIf="col.isModelProperty!='false'">

                        <ng-container *ngIf="col.property !== 'actions' && col.property !== 'action' ">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.property === 'actions' || col.property === 'action'">
                          <th mat-header-cell *matHeaderCellDef class="actions-cell">
                            {{ col.name }}
                          </th>
                        </ng-container>

                        <td mat-cell *matCellDef="let element ;let i = index" class="hover-cell">
                          <div class="cell-content-wrapper">
                            <div class="cell-data" style="padding-left: 15px;">

                              <ng-container [ngSwitch]="col.property">


                                <span *ngSwitchCase="'select'">

                                  <mat-checkbox [attr.guide]="sanitizedUrl + '-checkbox-' + element.incrementId"
                                    (click)="$event.stopPropagation()"
                                    (change)="changeValue($event.checked, element); $event ? selection.toggle(element) : null"
                                    [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                                  </mat-checkbox>

                                </span>

                                <span *ngSwitchCase="'image'">

                                  <span *ngIf="!element?.productImageUrl || !element.productImageUrl.includes('http')">
                                    <calsoft-common-images
                                      [src]="getImage(element.productImageUrl, element.images, element)"
                                      [height]="'65px'" [width]="'auto'" [alt]="element.name">
                                    </calsoft-common-images>
                                  </span>

                                  <span *ngIf="element?.productImageUrl && element.productImageUrl.includes('http')">
                                    <img style="height: 65px;width: auto;"
                                      [src]="element.productImageUrl | safe: 'resourceUrl'"
                                      onerror="this.src='assets/images/logo/no-image.png';" alt="">
                                  </span>


                                </span>

                                <span *ngSwitchCase="'isInStock'">
                                  <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else isInStockReadMode">

                                    <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                      [(ngModel)]="element.isInStock">

                                      <ng-container *ngIf="col.property == 'isInStock'">
                                        <mat-option *ngFor="let item of isInStock" [value]="item.value">
                                          {{item.viewValue}}
                                        </mat-option>
                                      </ng-container>

                                    </mat-select>

                                  </ng-container>
                                  <ng-template #isInStockReadMode>
                                    <div class="user-cell1">
                                      <span>
                                        {{element.isInStock == 1 ? "Yes" :
                                        "No"}}
                                      </span>

                                    </div>
                                  </ng-template>
                                </span>


                                <span *ngSwitchCase="'actions'">
                                  <button [attr.guide]="sanitizedUrl + '-action-menu-btn-v2'" type="button"
                                    mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                    (click)="$event.stopPropagation()">
                                    <mat-icon>more_horiz</mat-icon>
                                  </button>
                                  <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">

                                    <button [attr.guide]="sanitizedUrl + '-edit-product-v2-btn'"
                                      [disabled]="!resourcePrivilege?.update"
                                      (click)="editProduct(element.entityId,element.attributeSetId,element.type)"
                                      mat-menu-item>
                                      <mat-icon>edit</mat-icon>
                                      <span>edit</span>
                                    </button>

                                    <button [attr.guide]="sanitizedUrl + '-delete-product-v2-btn'"
                                      [disabled]="!resourcePrivilege?.update"
                                      (click)="deleteAllProductId(element.entityId)" mat-menu-item>
                                      <mat-icon>delete</mat-icon>
                                      <span>delete</span>
                                    </button>


                                  </mat-menu>
                                </span>



                                <span *ngSwitchDefault>
                                  <ng-container *ngIf="editingCell?.rowId === element.id 
                               && editingCell?.colProperty === col.property; else readMode">

                                    <input [attr.guide]="sanitizedUrl + '-input-' + col.property"
                                      *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element[col.property]"
                                      placeholder="Enter value" />

                                  </ng-container>
                                  <ng-template #readMode>
                                    <span *ngIf="col.property != 'qty'">
                                      {{ element[col.property] || '--' }}
                                    </span>
                                    <span *ngIf="col.property === 'qty'">
                                      {{ element[col.property] || '0' }}
                                    </span>
                                  </ng-template>
                                </span>

                              </ng-container>
                            </div>


                            <!-- <div *ngIf="col.property != 'actions'&& col.property != 'customerName'&& col.property != 'createdDate'&& col.property != 'updatedDate'
                                                     && col.property != 'owner'&& col.property != 'leadId'"
                             class="cell-actions">
 
                             <button [attr.guide]="'product-btn-edit-value' + '__' + sanitizedUrl" mat-icon-button
                               *ngIf="!(editingCell?.rowId === element.id && editingCell?.colProperty === col.property)"
                               aria-label="Edit value" class="icon-color icon-background">
                               <mat-icon
                                 (click)="startEdit(element.id, col.property, element, col); $event.stopPropagation()"
                                 style="font-size: 17px;">edit</mat-icon>
                             </button>
 
                             <button [attr.guide]="'product-btn-save-value' + '__' + sanitizedUrl" mat-icon-button
                               *ngIf="editingCell?.rowId === element.id && editingCell?.colProperty === col.property"
                               aria-label="Save value" class="icon-color icon-background">
                               <mat-icon
                                 (click)="saveEdit(element.id, col.property , element[col.property],element); $event.stopPropagation()"
                                 style="font-size: 17px;">check</mat-icon>
                             </button>
 
                             <button [attr.guide]="'product-btn-save-value' + '__' + sanitizedUrl" mat-icon-button
                               *ngIf="editingCell?.rowId === element.id && editingCell?.colProperty === col.property"
                               aria-label="Save value" class="icon-color icon-background">
                               <mat-icon
                                 (click)="closeEdit(element.id, col.property , element[col.property],element); $event.stopPropagation()"
                                 style="font-size: 17px;">close</mat-icon>
                             </button>
 
 
                           </div> -->
                          </div>
                        </td>


                      </ng-container>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: visibleColumns;">
                    </tr>

                  </table>
                  <div style="padding: 20px;" fxLayoutAlign="center center"
                    *ngIf="productList?.data?.length === 0 || productList?.length === 0">
                    No records found
                  </div>


                  <mat-paginator [attr.guide]="sanitizedUrl + '-pagination-v2'" class="paginator"
                    (page)="getUpdate($event)" showFirstLastButtons [length]="pageList" [pageIndex]="page"
                    [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                  </mat-paginator>

                </div>

              </div>


            </section>

          </main>
        </div>
      </div> <!-- Closes the [fxFlex]="rowLeft" div -->

      <!-- Modernized sliding filter panel -->
      <div class="side-form-container" *ngIf="isFilterPanelOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-height: 0;">
            <calsoft-filter-list-popup
              style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="1"
              [columns]="columns" [filterSelectObj]="filterSelectObj"
              (filterChangeColumn)="onFilterChangeColumn($event)" [name]="'Lead'"
              (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
          </div>
        </div>
      </div>

      <!-- Modernized sliding column visibility panel -->
      <div class="side-form-container" *ngIf="isFilterPanelColumnOpen" [fxFlex]="rowRight">
        <div class="side-form-card mat-elevation-z4" style="height: 100%;">
          <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title-area" fxLayout="row" fxLayoutAlign="space-between center">
              <h3 style="margin: 0; margin-left: 5px;">Filter By Column</h3>
            </div>
            <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel"
              [attr.guide]="sanitizedUrl + '-btn-close-filter-column'">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="side-form-content">
            <calsoft-column-visibility [columns]="columns" [filterType]="true"
              (filterChangeColumn)="onFilterChangeColumn($event)"
              (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
          </div>
        </div>
      </div>

    </div>

  </div>

</div>


<ng-template #delete>

  <div class="index-head">
    <span>Delete</span>
  </div>
  <div class="padding-index">
    <span> Do you want to Delete All Products</span>
  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="sanitizedUrl + '-dialog-delete-all-cancel-btn'" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="sanitizedUrl + '-dialog-delete-all-submit-btn'" [disabled]="textAccount !='OK'"
      (click)=" submit()" mat-raised-button>
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>

<ng-template #download>

  <div class="index-head">
    <span>Download</span>
  </div>

  <form [formGroup]="firstFormGroup">
    <div class="padding-10">

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Page</mat-label>
          <input [attr.guide]="sanitizedUrl + '-dialog-download-page-input'" matInput formControlName="page" required />
          <mat-error *ngIf="firstFormGroup.controls.page.errors?.required">
            Please fill out this Field.
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Size</mat-label>
          <input [attr.guide]="sanitizedUrl + '-dialog-download-size-input'" matInput formControlName="size" required />
          <mat-error *ngIf="firstFormGroup.controls.size.errors?.required">
            Please fill out this Field.
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Sort Value</mat-label>
          <mat-select formControlName="sort">
            <mat-option *ngFor="let status of filterSelectObjDub" [value]="status.property">
              {{status.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="firstFormGroup.controls.sort.errors?.required">
            Please fill out this Field.
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Sord By</mat-label>
          <mat-select formControlName="sortBy">
            <mat-option *ngFor="let status of booleanField" [value]="status.value">
              {{status.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="sanitizedUrl + '-dialog-download-cancel-btn'" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <!-- <button [attr.guide]="'product-btn-52' + '__' + sanitizedUrl" mat-raised-button (click)="submit()">Submit</button> -->
    <button [attr.guide]="sanitizedUrl + '-dialog-download-submit-btn'" [disabled]="downloadDataComplete !='OK'"
      (click)=" downloadData()" mat-raised-button>
      {{downloadDataComplete}}
      <mat-icon *ngIf="downloadDataComplete !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>


<ng-template #delete1>

  <div class="index-head">
    <span>Delete</span>
  </div>
  <div class="padding-index">
    <span>Sure Want to delete the Product</span>
  </div>

  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="sanitizedUrl + '-dialog-delete-cancel-btn-v2'" mat-raised-button mat-dialog-close
      tabindex="-1">Cancel</button>
    <button [attr.guide]="sanitizedUrl + '-dialog-delete-submit-btn-v2'" [disabled]="textAccount !='OK'"
      (click)="submit1()" mat-raised-button>
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>